export function splitLapKey(sessionId, lapIndex) {
  return `${sessionId}:${lapIndex}`;
}

export function pruneSplitDisabledKeys(disabledKeys, sessionIds) {
  const prefixes = (sessionIds || []).map(sessionId => `${sessionId}:`);
  return new Set(
    [...disabledKeys].filter(key => prefixes.some(prefix => key.startsWith(prefix))),
  );
}

export function buildSplitTimeGroups(datasets, mismatchThreshold) {
  return (datasets || []).map(dataset => {
    const mismatch = Number.isFinite(dataset.sfOffsetM)
      && dataset.sfOffsetM >= mismatchThreshold;
    const laps = (dataset.data?.laps || [])
      .filter(lap => !lap.is_outlap && !lap.is_inlap)
      .map((lap, index) => ({
        ...lap,
        displayNumber: index + 1,
        rowKey: splitLapKey(dataset.sessionId, lap.lap_index),
      }));
    return { ...dataset, mismatch, laps };
  });
}

function perSector(rows, sectorCount, select) {
  return Array.from({ length: sectorCount }, (_, index) => {
    const values = rows
      .map(row => row.sector_times?.[index])
      .filter(value => value != null && Number.isFinite(value));
    return values.length ? select(values) : null;
  });
}

function roundMillis(value) {
  return Math.round(value * 1000) / 1000;
}

function sumComplete(values) {
  return values.every(value => value != null)
    ? roundMillis(values.reduce((sum, value) => sum + value, 0))
    : null;
}

export function computeSplitTimeStats(rows, sectorCount) {
  const best = perSector(rows, sectorCount, values => Math.min(...values));
  const avg = perSector(rows, sectorCount, values => (
    roundMillis(values.reduce((sum, value) => sum + value, 0) / values.length)
  ));
  const max = perSector(rows, sectorCount, values => Math.max(...values));
  const lapTotals = rows
    .map(row => row.lap_time_seconds)
    .filter(value => value != null && Number.isFinite(value) && value > 0);

  return {
    best,
    avg,
    max,
    bestTotal: sumComplete(best),
    avgTotal: lapTotals.length
      ? roundMillis(lapTotals.reduce((sum, value) => sum + value, 0) / lapTotals.length)
      : null,
    maxTotal: lapTotals.length ? Math.max(...lapTotals) : null,
  };
}
